import React from 'react';
import { BrowserRouter as BaseRouter, Navigate, Route, Routes } from 'react-router-dom';
import routes, { RouteEnum } from './routes';
import AuthMiddleware from './AuthMiddleware';
import { partnerAwarePath } from '../services/branding/partnerSlugStorage';
import Layout from '../components/layout/Layout';
import ChannelStack from '../channels/ChannelStack';
import AlertScreensStack from '../views/alerts/AlertScreensStack';

export default function Router() {
  return (
    <BaseRouter>
      <Routes>
        {routes.map(
          (route, idx) =>
            route.component && (
              <Route
                key={`route-${idx}`}
                path={route.path}
                element={
                  route.is_private ? (
                    <AuthMiddleware>
                      <Layout>
                        <route.component />
                      </Layout>
                    </AuthMiddleware>
                  ) : (
                    <route.component />
                  )
                }
              />
            ),
        )}
        <Route path="*" element={<Navigate to={partnerAwarePath(RouteEnum.Login)} replace />} />
      </Routes>
      <ChannelStack />
      <AlertScreensStack />
    </BaseRouter>
  );
}
